import { ModalStore } from 'ui/base/modal/modal_store';
import { BooleanStore } from 'ui/base/input';
import { action, computed, observable } from 'mobx';
import { ORDERED_SEEN, Seen } from 'assets/enums/seen/seen';

export class SeenStore {
  @observable.deep values: Record<Seen, boolean>;
  workspace: Record<Seen, BooleanStore>;

  modal: ModalStore;

  constructor(initial: Record<Seen, boolean>) {
    this.values = {
      [Seen.SEEN]: initial[Seen.SEEN],
      [Seen.UNSEEN]: initial[Seen.UNSEEN],
    };

    this.workspace = {
      [Seen.SEEN]: new BooleanStore(this.values[Seen.SEEN]),
      [Seen.UNSEEN]: new BooleanStore(this.values[Seen.UNSEEN]),
    };

    this.modal = new ModalStore(false);
  }

  // This triggers a reload from the stored values to the workspace
  // This is best used before opening the modal
  @action.bound
  reloadWorkspace(): void {
    Object.entries(this.workspace).forEach(([dir, store]) => {
      store.value = this.values[dir as Seen];
    });
  }

  // This triggers a commit to the workspace from the stored values
  // Best used before closing and saving the modal
  @action.bound
  commitWorkspace(): void {
    Object.entries(this.workspace).forEach(([dir, store]) => {
      this.values[dir as Seen] = store.value;
    });
  }

  @computed get arrayValue(): Seen[] {
    return ORDERED_SEEN.filter((dir) => this.values[dir] === true);
  }

  @computed get workspaceHasChecked(): boolean {
    return Object.values(this.workspace).some((store) => store.value);
  }
}
